import fieldTypes from '../../../../../../enums/FieldTypes';
import stripCharacters from '../../../../../utils/strip-characters';
import addressee from '../../defaultFieldDefinitions/Addressee';
import addressLine2 from '../../defaultFieldDefinitions/AddressLine2';
import companyName from '../../defaultFieldDefinitions/CompanyName';
import houseNameOrNumber from '../../defaultFieldDefinitions/HouseNameOrNumber';
import streetName from '../../defaultFieldDefinitions/StreetName';
import townCity from '../../defaultFieldDefinitions/TownCity';
import * as max from '../../max-length-validators';
import PredictionsByField from '../../PredictionsByField';
import * as required from '../../required-validators';
import {sixDigitsPostcodeValidator} from '../../setDigitsPostcodeValidator';
import validateAutocompleteField from '../../validateAutocompleteField';

const formatROPostcode = (value) => {
  if (!value) return value;
  return value.replace(/\s/g, '');
};

const provinces = PredictionsByField.county('RO');

const FieldDefinitionRO = [
  addressee,
  {
    name: 'postCode',
    label: 'checkout.delivery.address.field.label.postal.code.text',
    required: true,
    maxLength: 6,
    transform: formatROPostcode,
    validate: [required.postCode, sixDigitsPostcodeValidator],
    validationCleaner: stripCharacters(' '),
  },
  companyName,
  {
    ...houseNameOrNumber,
    maxLength: 16,
    validate: [required.houseNumber, max.lengthHouseNumber(16)],
  },
  streetName,
  addressLine2,
  townCity,
  {
    name: 'county',
    label: 'checkout.address.field.label.county.text',
    required: true,
    element: fieldTypes.AUTOCOMPLETE,
    placeholder: 'checkout.delivery.address.field.placeholder.county.autoComplete',
    predictions: provinces,
    validate: [required.county, validateAutocompleteField(provinces, 'county')],
  },
];

export default FieldDefinitionRO;
